import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import "./BubbleChart.css"
import more from 'highcharts/highcharts-more.js';
import Exporting from 'highcharts/modules/exporting.js';

more(Highcharts);
Exporting(Highcharts);

const defaultOptions = {
    legend: {
        enabled: false
    },
    plotOptions: {
        series: {
            animation: false,
            dataLabels: {
                enabled: true,
            }
        }
    }
    
}

class BubbleChart extends Component {
  	constructor(props) {
		super(props);
  	}

	render() {
        Highcharts.setOptions({
            lang: {
                thousandsSep: ','
              }
        });
        let newDefaultOptions = {...defaultOptions}
        return (
            <div id={this.props.containerId}>
                <HighchartsReact
                    options = {{
                        ...newDefaultOptions,
                        ...this.props.remainingOptions,
                    }}
                    highcharts = { Highcharts }
                    ref={this.props.bubbleChartRef? this.props.bubbleChartRef : undefined}
                /> 
            </div>
        )
	}
}


export default BubbleChart;
